import { ACTIONS } from './actions';
import { initialState } from './initialState'

export const reducer = (state, action) => {
   switch (action.type) {
      case ACTIONS.SET:
         return { ...state, [action.entity]: action.payload, }
      case ACTIONS.ADD_TICKET:
         return {
            ...state,
            cart: [...state.cart, action.payload],
         };
      case ACTIONS.ADD_TICKET_ADDONS:
         return {
            ...state,
            cart: state.cart.map(t => {
               if (t.id === action.payload.cartItem.id) {
                  t.addOns = [...t.addOns, action.payload.addOn]
               }
               return t
            })
         };
      case ACTIONS.UPDATE_TICKET:
         return {
            ...state,
            cart: state.cart.map(t => {
               if (t.id === action.payload.id) {
                  t = { ...t, ...action.payload }
               }
               return t
            })
         };
      case ACTIONS.REMOVE_TICKET:
         let found = false
         return {
            ...state,
            cart: state.cart.reverse().filter(i => {
               if (i.type_id === action.payload.type_id && !found) {
                  found = true;
                  return false;
               }
               return true
            }).reverse(),
         };
      case ACTIONS.REMOVE_TICKET_ADDONS:
         return {
            ...state,
            cart: state.cart.map(t => {
               if (t.id === action.payload.cartItem.id) {
                  t.addOns = t.addOns?.filter(i => i.id !== action.payload.addOn.id)
               }
               return t
            })
         };
      case ACTIONS.REMOVE_TICKETS:
         return {
            ...state,
            cart: []
         };
      case ACTIONS.RESET_CART:
         return {
            ...state,
            currStageIdx: 0,
            cart: [],
            // promoCode: '',
            orderResponse: {},
            paymentInfo: initialState.paymentInfo,
            invalidInputMsg: [],
         };
         case ACTIONS.SET_MODAL_STATUS:
            return{
               ...state,
               modals: {
                  ...state.modals,
                  [action.payload.modal]: action.payload.status,
               },
            }
      default:
         return state
   }
};

